<template>
  <div>
    <h1>500 Server Error</h1>
    <p>サーバーで問題が発生しているためページを表示できません。</p>
    <p>しばらく時間を置いてから操作をやり直してください。</p>
  </div>
</template>

<script setup lang="ts"></script>
